var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ml-tag",style:(`background: ${_vm.bg}`)},[_c('span',{style:(`color: ${_vm.color}`)},[(_vm.dot)?_c('b',{style:(`background: ${_vm.color};`)}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }